<template>
  <div class="mb-4 flex border-b">
    <button
      class="border-b-2 px-4 py-2"
      :class="selectedTab === 'region' ? 'font-semibold' : 'border-transparent text-gray-500'"
      @click="(selectedTab = 'region')"
    >
      Regiones
    </button>
    <button
      class="border-b-2 px-4 py-2"
      :class="selectedTab === 'commune' ? 'font-semibold' : 'border-transparent text-gray-500'"
      @click="(selectedTab = 'commune')"
    >
      Comunas
    </button>
  </div>
  <table class="w-full text-sm md:text-base">
    <thead v-if="filteredConstrains.length">
      <tr class="border-b">
        <th class="py-2 text-left">Destino</th>
        <th class="py-2 text-left">¿Se despacha?</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="destinationConstrain in filteredConstrains"
        :key="destinationConstrain.id"
        class="border-b"
      >
        <td class="py-2">{{ getDestinationName(destinationConstrain) }}</td>
        <td class="py-2">
          <span :class="destinationConstrain.active ? 'text-green-600' : 'text-red-600'">
            {{ destinationConstrain.active ? 'Sí se despacha' : 'No se despacha' }}
          </span>
        </td>
      </tr>
      <tr v-if="filteredConstrains.length === 0">
        <td
          colspan="2"
          class="text-gray-400"
        >
          Sin restricciones para {{ selectedTab === 'region' ? 'regiones' : 'comunas' }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';

const props = defineProps<{
  destinationConstrains: DestinationConstrain[];
}>();

const selectedTab = ref<'region' | 'commune'>('region');

const filteredConstrains = computed(() =>
  props.destinationConstrains.filter(
    (destinationConstrain) => destinationConstrain.destinationableType.toLowerCase() === selectedTab.value,
  ),
);

function getDestinationName(destinationConstrain: DestinationConstrain): string {
  return destinationConstrain.destinationableName;
}
</script>
